import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {EmployeeSearchModel} from "../employee-search.model";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {EmployeeSearchPageComponent} from "../employee-search-page/employee-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-employee-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(EmployeeSearchModel),
        registerSearchControl(EmployeeMultiSelectSearchControlComponent)
    ]
})
export class EmployeeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<EmployeeSearchModel> {
    constructor(model: EmployeeSearchModel, injector: Injector) {
        super(model, injector, "employeeId", "userName");
        this.extendedSearchComponent = EmployeeSearchPageComponent;
    }
}
